<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Dedicated Proxies'"
        :buttons="[
          {
            title: 'Add Proxy',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'DedicatedProxies'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
          :addContextMenuItem="getContextMenuItems"
        @cellClicked="updateShow = $event.data"
      ></dataTable>
      <upsert
        v-if="addShow || (updateShow != null && data != null)"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        :operators="data"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
import moment from "moment";
export default {
  name: "DedicatedProxies",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 60,
        },
        {
          headerName: "ProviderName",
          field: "ProviderName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "IpAddress",
          field: "IpAddress",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "OutputIp",
          field: "OutputIp",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Port",
          field: "Port",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Username",
          field: "Username",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Password",
          field: "Password",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "CreateDate",
          field: "CreateDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "IsTrafficBillable",
          field: "IsTrafficBillable",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsActive",
          field: "IsActive",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`DedicatedProxies`).then((response) => {
      this.data = response.data;
    });
  },
  methods:{

    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Output Ip Search And Update",
          icon: '<i class="far fa-question-circle"></i>',
          action: () => {
            this.$appAxiosAdmin.get(`DedicatedProxies/ip/`+params.node.data.Id).then((response) => {
              this.$swal({
                icon: "info",
                title: "Output Ip",
                text: response.data,
                confirmButtonText: "Okey",
              });
              this.$refs.agGrid.changeRow('Id', {...params.node.data,OutputIp:response.data})
            });
          },
        },
      ];
      return result;
    },
  }
};
</script>
